import UltMeta, { Meta } from "@/meta/UltMeta/index";

class SignatureStatus extends UltMeta {
    NOT_SIGNED = new Meta(1, "未签收", "#000000e0");
    SIGNING = new Meta(2, "签收中", "#000000e0");
    SIGNED = new Meta(3, "已签收", "#00000066");
}

export const SIGNATURE_STATUS = new SignatureStatus();
